<template>
  <div class="page-not-found min-h-screen flex items-center justify-center bg-slate-900">
    <div class="text-center">
      <h1 class="text-9xl font-bold text-slate-700">404</h1>
      <p class="text-xl text-slate-400 mt-4">抱歉，您访问的页面不存在</p>
      <router-link
        to="/dashboard"
        class="btn-primary mt-6"
      >
        返回首页
      </router-link>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'PageNotFound'
})
</script>
